module.exports = __webpack_public_path__ + "static/media/15.950df0d8.png";